import { render } from "./TowerCard.vue?vue&type=template&id=5d2e9d02&scoped=true&ts=true"
import script from "./TowerCard.vue?vue&type=script&lang=ts"
export * from "./TowerCard.vue?vue&type=script&lang=ts"

import "./TowerCard.vue?vue&type=style&index=0&id=5d2e9d02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2e9d02"]])

export default __exports__